import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Tag from './components/Tag';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import React, { useEffect } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "./fonts/Frankie.ttf"

function App() {

  useEffect(() => {
    // Register ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);


    gsap.fromTo(
      '.up_1',
      // From properties (initial state)
      {
        opacity: 0,
        y: 20,
      },
      // To properties (final state)
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power2.out',
      }
    );
    gsap.fromTo(
      '.right_anim',
      // From properties (initial state)
      {
        opacity: 0,
        x: 100,
      },
      // To properties (final state)
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: 'power2.out',
      }
    );
    gsap.fromTo(
      '.transform_left',
      // From properties (initial state)
      {
        opacity: 0,
        x: -100,
      },
      // To properties (final state)
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: 'power2.out',
      }
    );
    
    gsap.fromTo(
      '.transform_left_2',
      // From properties (initial state)
      {
        opacity: 0,
        x: -100,
      },
      // To properties (final state)
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: 'power2.out',
      }
    );
    


  }, []);

  useEffect(() => {
    AOS.init({
      // Global settings for AOS initialization
      // You can customize these settings based on your requirements
      once: true, // Whether animation should happen only once on scroll
      duration: 800, // Animation duration in milliseconds
      offset: 100, // Offset (in pixels) from the original trigger point
      easing: 'ease-in-out', // Easing function for animations
    });
  }, []);


  return (
    <div className="App">
      <Navbar/>
      <Home/>
      <Tag section_heading="About me" top={0} left={-10} />
      <About/>
      <Tag section_heading="My Skills" top={0} left={-10} />
      <Skills/>
      <Tag section_heading="Projects" top={0} left={-10} />
      <Projects />
      <Tag section_heading="Get In Touch" top={0} left={-10} />
      <Contact/>
      <Footer/>
      
    </div>
  );
}

export default App;
